export const OUTPUT_SAMPLE_RATE = 16000

// Protocole d'offset Praxy (API >= v1.19.109) : « OFFS » (4 o) + offset uint64 LE (8 o) + PCM int16
export const AUDIO_OFFSET_HEADER = 12
// Octets ASCII en dur : TextEncoder n'existe pas dans l'environnement jsdom de jest
const OFFS_MAGIC = new Uint8Array([0x4f, 0x46, 0x46, 0x53]) // "OFFS"
const UINT32_RANGE = 2 ** 32

export const buildOffsetFrame = (pcm: Int16Array, offset: number): Uint8Array => {
  const frame = new Uint8Array(AUDIO_OFFSET_HEADER + pcm.byteLength)
  frame.set(OFFS_MAGIC, 0)
  const view = new DataView(frame.buffer)
  view.setUint32(4, offset % UINT32_RANGE, true)
  view.setUint32(8, Math.floor(offset / UINT32_RANGE), true)
  frame.set(new Uint8Array(pcm.buffer, pcm.byteOffset, pcm.byteLength), AUDIO_OFFSET_HEADER)
  return frame
}

export const EOF_FRAME = new Uint8Array([0x45, 0x4f, 0x46]) // "EOF"

export const decreaseSampleRate = (
  buffer: Float32Array,
  inputSampleRate: number,
  outputSampleRate: number,
): Float32Array | null => {
  if (inputSampleRate <= outputSampleRate) {
    return buffer
  }

  const sampleRateRatio = inputSampleRate / outputSampleRate
  const newLength = Math.ceil(buffer.length / sampleRateRatio)
  const result = new Float32Array(newLength)
  let offsetResult = 0
  let offsetBuffer = 0

  while (offsetResult < result.length) {
    const nextOffsetBuffer = Math.round((offsetResult + 1) * sampleRateRatio)
    let accum = 0
    let count = 0
    for (let i = offsetBuffer; i < nextOffsetBuffer && i < buffer.length; i++) {
      accum += buffer[i]
      count++
    }
    result[offsetResult] = accum / count
    offsetResult++
    offsetBuffer = nextOffsetBuffer
  }
  return result
}

export const convertFloat32ToInt16 = (buffer: Float32Array): Int16Array => {
  let l = buffer.length
  const buf = new Int16Array(l)
  const maxInt = 0x7fff
  while (l--) {
    const sample = Math.max(-1.0, Math.min(1.0, buffer[l]))
    buf[l] = Math.round(sample * maxInt)
  }
  return buf
}
